import { businessIsAllowedToSeeFeature } from '@/router/validators/utils/businessIsAllowedToSeeFeature';
import { ValidatorState } from '../types';
import { countryHasProviders } from '../utils';

export function loyaltyWidgetValidator(): ValidatorState {
  let disclaimersKeys: Array<string> = [];
  const isValid =
    countryHasProviders() && businessIsAllowedToSeeFeature('online');

  return {
    isValid,
    disclaimersKeys
  };
}
